import React from 'react';

import { FilterButtonListContainer, FilterContainerTitle, FiltersContainer } from './styled';

export function FilterButtonList({ children }: { children: React.ReactNode }) {
  return (
    <FiltersContainer>
      <FilterContainerTitle>Filters</FilterContainerTitle>
      <FilterButtonListContainer>{children}</FilterButtonListContainer>
    </FiltersContainer>
  );
}
